var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"empty-card",style:({'height':_vm.height})},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tips-icon-card"},[_c('img',{staticClass:"tips-img",attrs:{"src":require("../../static/icon-empty.png")}})])
}]

export { render, staticRenderFns }